import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const SECOES = [
  { id: 'geral',         icon: 'ti-building',      label: 'Geral' },
  { id: 'usuario',       icon: 'ti-user-circle',   label: 'Minha conta' },
  { id: 'notificacoes',  icon: 'ti-bell',          label: 'Notificações' },
  { id: 'aparencia',     icon: 'ti-palette',       label: 'Aparência' },
];

export default function Configuracoes() {
  const [secao, setSecao] = useState('geral');

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.title}><i className="ti ti-settings" style={{ fontSize: 18 }} /> Configurações</div>
        <div style={s.sub}>Personalize a plataforma conforme suas necessidades</div>
      </div>

      <div style={s.body}>
        {/* Menu lateral */}
        <div style={s.menu}>
          {SECOES.map(sec => (
            <button
              key={sec.id}
              style={{ ...s.menuItem, ...(secao === sec.id ? s.menuItemActive : {}) }}
              onClick={() => setSecao(sec.id)}
            >
              <i className={`ti ${sec.icon}`} style={{ fontSize: 16 }} />
              {sec.label}
            </button>
          ))}
        </div>

        {/* Conteúdo */}
        <div style={s.content}>
          {secao === 'geral'        && <SecaoGeral />}
          {secao === 'usuario'      && <SecaoUsuario />}
          {secao === 'notificacoes' && <SecaoNotificacoes />}
          {secao === 'aparencia'    && <SecaoAparencia />}
        </div>
      </div>
    </div>
  );
}

function SecaoGeral() {
  const [form,    setForm]    = useState({ nome_empresa: 'Match Jurídico', site: 'https://mjmatchjuridico.com.br', horario_inicio: '08:00', horario_fim: '18:00' });
  const [salvo,   setSalvo]   = useState(false);
  const [salvando,setSalvando]= useState(false);

  async function salvar() {
    setSalvando(true);
    setTimeout(() => { setSalvo(true); setSalvando(false); setTimeout(() => setSalvo(false), 2000); }, 500);
  }

  return (
    <div style={s.secao}>
      <div style={s.secaoTitle}>Informações da empresa</div>
      <div style={s.grid2}>
        <Field label="Nome da empresa">
          <input style={s.input} value={form.nome_empresa} onChange={e => setForm(p => ({...p, nome_empresa: e.target.value}))} />
        </Field>
        <Field label="Site">
          <input style={s.input} value={form.site} onChange={e => setForm(p => ({...p, site: e.target.value}))} />
        </Field>
      </div>

      <div style={s.secaoTitle}>Horário de funcionamento</div>
      <div style={s.grid2}>
        <Field label="Abertura">
          <input type="time" style={s.input} value={form.horario_inicio} onChange={e => setForm(p => ({...p, horario_inicio: e.target.value}))} />
        </Field>
        <Field label="Fechamento">
          <input type="time" style={s.input} value={form.horario_fim} onChange={e => setForm(p => ({...p, horario_fim: e.target.value}))} />
        </Field>
      </div>

      <div style={s.secaoTitle}>Dias de funcionamento</div>
      <DiasSemana />

      <Botoes salvo={salvo} salvando={salvando} onSalvar={salvar} />
    </div>
  );
}

function SecaoUsuario() {
  const { usuario } = useAuth();
  const [form,     setForm]     = useState({ nome: usuario?.nome || '', email: usuario?.email || '' });
  const [senha,    setSenha]    = useState({ atual: '', nova: '', confirmar: '' });
  const [salvo,    setSalvo]    = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro,     setErro]     = useState('');

  async function salvarPerfil() {
    setSalvando(true); setErro('');
    setTimeout(() => { setSalvo(true); setSalvando(false); setTimeout(() => setSalvo(false), 2000); }, 500);
  }

  async function salvarSenha() {
    if (!senha.atual || !senha.nova) return setErro('Preencha todos os campos.');
    if (senha.nova !== senha.confirmar) return setErro('As senhas não coincidem.');
    if (senha.nova.length < 6) return setErro('A senha deve ter pelo menos 6 caracteres.');
    setErro('');
    setSalvando(true);
    try {
      await api.put('/auth/senha', { senha_atual: senha.atual, senha_nova: senha.nova });
      setSenha({ atual: '', nova: '', confirmar: '' });
      setSalvo(true);
      setTimeout(() => setSalvo(false), 2000);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao alterar senha.');
    }
    setSalvando(false);
  }

  const av = usuario?.nome ? usuario.nome.split(' ').map(n => n[0]).join('').substring(0,2).toUpperCase() : 'AC';

  return (
    <div style={s.secao}>
      <div style={s.secaoTitle}>Foto de perfil</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--green)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 700 }}>
          {av}
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-primary)', marginBottom: 4 }}>{usuario?.nome}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>{usuario?.email}</div>
          <span style={{ fontSize: 11, background: 'var(--bg-app)', padding: '3px 10px', borderRadius: 99, color: 'var(--text-secondary)', border: '1px solid var(--border)' }}>
            {usuario?.perfil === 'admin' ? 'Administrador' : usuario?.perfil === 'supervisor' ? 'Supervisor' : 'Atendente'}
          </span>
        </div>
      </div>

      <div style={s.secaoTitle}>Dados pessoais</div>
      <div style={s.grid2}>
        <Field label="Nome completo">
          <input style={s.input} value={form.nome} onChange={e => setForm(p => ({...p, nome: e.target.value}))} />
        </Field>
        <Field label="Email">
          <input style={s.input} value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} disabled />
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>O email não pode ser alterado</div>
        </Field>
      </div>
      <Botoes salvo={salvo} salvando={salvando} onSalvar={salvarPerfil} />

      <div style={{ ...s.secaoTitle, marginTop: 32 }}>Alterar senha</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 400 }}>
        <Field label="Senha atual">
          <input type="password" style={s.input} value={senha.atual} onChange={e => setSenha(p => ({...p, atual: e.target.value}))} />
        </Field>
        <Field label="Nova senha">
          <input type="password" style={s.input} value={senha.nova} onChange={e => setSenha(p => ({...p, nova: e.target.value}))} />
        </Field>
        <Field label="Confirmar nova senha">
          <input type="password" style={s.input} value={senha.confirmar} onChange={e => setSenha(p => ({...p, confirmar: e.target.value}))} />
        </Field>
        {erro && <div style={{ padding: '8px 12px', background: '#fef2f2', borderRadius: 8, fontSize: 12, color: '#dc2626' }}>{erro}</div>}
        <button style={{ ...s.btn, ...s.btnPrimary, alignSelf: 'flex-start' }} onClick={salvarSenha} disabled={salvando}>
          {salvando ? 'Salvando...' : 'Alterar senha'}
        </button>
      </div>
    </div>
  );
}

function SecaoNotificacoes() {
  const [config, setConfig] = useState({
    nova_conversa:     true,
    nova_mensagem:     true,
    transferencia:     true,
    som:               true,
    desktop:           false,
  });
  const [salvo, setSalvo] = useState(false);

  function salvar() {
    setSalvo(true);
    setTimeout(() => setSalvo(false), 2000);
  }

  return (
    <div style={s.secao}>
      <div style={s.secaoTitle}>Notificações do sistema</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Toggle label="Nova conversa" sub="Notificar quando chegar uma nova conversa" value={config.nova_conversa} onChange={v => setConfig(p => ({...p, nova_conversa: v}))} />
        <Toggle label="Nova mensagem" sub="Notificar quando chegar nova mensagem em conversa aberta" value={config.nova_mensagem} onChange={v => setConfig(p => ({...p, nova_mensagem: v}))} />
        <Toggle label="Transferência" sub="Notificar quando uma conversa for transferida para você" value={config.transferencia} onChange={v => setConfig(p => ({...p, transferencia: v}))} />
      </div>

      <div style={{ ...s.secaoTitle, marginTop: 24 }}>Preferências de som e notificação</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Toggle label="Som de notificação" sub="Tocar som ao receber novas mensagens" value={config.som} onChange={v => setConfig(p => ({...p, som: v}))} />
        <Toggle label="Notificações no desktop" sub="Exibir notificações do sistema operacional" value={config.desktop} onChange={v => setConfig(p => ({...p, desktop: v}))} last />
      </div>

      <Botoes salvo={salvo} salvando={false} onSalvar={salvar} />
    </div>
  );
}

function SecaoAparencia() {
  const [tema,   setTema]   = useState('claro');
  const [cor,    setCor]    = useState('#6C3FC5');
  const [salvo,  setSalvo]  = useState(false);

  const CORES = ['#6C3FC5','#2563eb','#0891b2','#059669','#d97706','#dc2626','#db2777','#7c3aed'];

  function salvar() {
    document.documentElement.style.setProperty('--green', cor);
    document.documentElement.style.setProperty('--green-dark', cor + 'cc');
    setSalvo(true);
    setTimeout(() => setSalvo(false), 2000);
  }

  return (
    <div style={s.secao}>
      <div style={s.secaoTitle}>Tema</div>
      <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
        {[['claro','Claro','ti-sun'],['escuro','Escuro','ti-moon']].map(([id,label,icon]) => (
          <button
            key={id}
            style={{ ...s.temaBtn, ...(tema === id ? s.temaBtnActive : {}) }}
            onClick={() => setTema(id)}
          >
            <i className={`ti ${icon}`} style={{ fontSize: 20 }} />
            <span style={{ fontSize: 12, fontWeight: 500 }}>{label}</span>
          </button>
        ))}
      </div>

      <div style={s.secaoTitle}>Cor principal</div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 24, flexWrap: 'wrap' }}>
        {CORES.map(c => (
          <button
            key={c}
            onClick={() => setCor(c)}
            style={{
              width: 36, height: 36, borderRadius: '50%', border: cor === c ? '3px solid #fff' : '3px solid transparent',
              background: c, cursor: 'pointer', outline: cor === c ? `3px solid ${c}` : 'none', transition: 'all 0.15s',
            }}
          />
        ))}
      </div>

      <div style={s.secaoTitle}>Prévia</div>
      <div style={{ background: 'var(--bg-app)', borderRadius: 12, padding: 16, marginBottom: 24, border: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: cor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="ti ti-brand-whatsapp" style={{ color: '#fff', fontSize: 16 }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ height: 10, background: cor, borderRadius: 4, width: '60%', marginBottom: 4, opacity: 0.8 }} />
            <div style={{ height: 8, background: 'var(--border)', borderRadius: 4, width: '40%' }} />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ padding: '8px 14px', borderRadius: '14px 4px 14px 14px', background: cor + '22', border: `1px solid ${cor}44`, fontSize: 12, color: cor }}>
            Prévia da cor selecionada
          </div>
        </div>
      </div>

      <Botoes salvo={salvo} salvando={false} onSalvar={salvar} label="Aplicar aparência" />
    </div>
  );
}

function DiasSemana() {
  const DIAS = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
  const [ativos, setAtivos] = useState([1,2,3,4,5]);
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap' }}>
      {DIAS.map((d, i) => (
        <button
          key={i}
          onClick={() => setAtivos(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i].sort())}
          style={{
            padding: '6px 14px', borderRadius: 99, fontSize: 12, fontWeight: 500, cursor: 'pointer',
            border: `1.5px solid ${ativos.includes(i) ? 'var(--green)' : 'var(--border)'}`,
            background: ativos.includes(i) ? 'var(--green)' : 'transparent',
            color: ativos.includes(i) ? '#fff' : 'var(--text-secondary)',
            transition: 'all 0.15s',
          }}
        >
          {d}
        </button>
      ))}
    </div>
  );
}

function Toggle({ label, sub, value, onChange, last }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0', borderBottom: last ? 'none' : '1px solid var(--border)' }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-primary)' }}>{label}</div>
        {sub && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{sub}</div>}
      </div>
      <button
        type="button"
        onClick={() => onChange(!value)}
        style={{ width: 42, height: 24, borderRadius: 99, border: 'none', cursor: 'pointer', background: value ? 'var(--green)' : 'var(--border)', position: 'relative', flexShrink: 0, marginLeft: 16, transition: 'background 0.2s' }}
      >
        <span style={{ position: 'absolute', width: 18, height: 18, borderRadius: '50%', background: '#fff', top: 3, left: value ? 21 : 3, transition: 'left 0.2s' }} />
      </button>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>{label}</label>
      {children}
    </div>
  );
}

function Botoes({ salvo, salvando, onSalvar, label }) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
      <button style={{ ...s.btn, ...s.btnPrimary }} onClick={onSalvar} disabled={salvando}>
        <i className="ti ti-device-floppy" style={{ fontSize: 14 }} />
        {salvando ? 'Salvando...' : label || 'Salvar alterações'}
      </button>
      {salvo && (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#14532d', background: '#dcfce7', padding: '6px 12px', borderRadius: 99 }}>
          <i className="ti ti-check" style={{ fontSize: 12 }} /> Salvo com sucesso!
        </span>
      )}
    </div>
  );
}

const s = {
  page:    { flex: 1, overflowY: 'auto', padding: 28, background: 'var(--bg-app)' },
  header:  { marginBottom: 24 },
  title:   { fontSize: 18, fontWeight: 600, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 },
  sub:     { fontSize: 13, color: 'var(--text-muted)' },
  body:    { display: 'flex', gap: 24, alignItems: 'flex-start' },
  menu:    { width: 200, background: '#fff', borderRadius: 12, border: '1px solid var(--border)', padding: 8, flexShrink: 0 },
  menuItem:{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, border: 'none', background: 'transparent', fontSize: 13, fontWeight: 500, color: 'var(--text-secondary)', cursor: 'pointer', width: '100%', transition: 'all 0.15s' },
  menuItemActive: { background: 'var(--bg-selected)', color: 'var(--green)' },
  content: { flex: 1, background: '#fff', borderRadius: 12, border: '1px solid var(--border)', padding: 24 },
  secao:   { display: 'flex', flexDirection: 'column' },
  secaoTitle: { fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 0.5, paddingBottom: 8, borderBottom: '1px solid var(--border)' },
  grid2:   { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 8 },
  input:   { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', fontSize: 13, color: 'var(--text-primary)', fontFamily: 'var(--font-sans)' },
  btn:     { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 16px', borderRadius: 9, border: '1px solid var(--border)', background: 'transparent', fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', cursor: 'pointer' },
  btnPrimary: { background: 'var(--green)', borderColor: 'var(--green)', color: '#fff' },
  temaBtn: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '16px 24px', borderRadius: 12, border: '2px solid var(--border)', background: 'transparent', cursor: 'pointer', color: 'var(--text-secondary)', transition: 'all 0.15s' },
  temaBtnActive: { borderColor: 'var(--green)', color: 'var(--green)', background: 'var(--bg-selected)' },
};